export default {
  // Loading Page
  loading: {
    title: "Getting Your Workspace Ready",
    message: "Please wait while we prepare your dashboard..."
  },
  // Sidebar Navigation
  sidebar: {
    dashboard: "Dashboard",
    recommendations: "Recommendations",
    organizationDesign: "Organization Design",
    talentPool: "Talent Pool",
    reports: "Reports",
    notifications: "Notifications",
    switchOrg: "Switch Org",
    settings: "Settings"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relationship added successfully",
    relationshipRemovedSuccessfully: "Relationship removed successfully",
    relationshipSavedSuccessfully: "Relationship Saved Successfully",
    profileCard: "Profile Card",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Hierarchy",
      network: "Network"
    },
    searchPlaceholder: "Search users...",
    networkSearchPlaceholder: "Search network...",
    hierarchySearchPlaceholder: "Search hierarchy...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Create",
      roleCreatedSuccessfully: "Role Created successfully",
      delete: "Delete",
      roleDeletedSuccessfully: "Role deleted successfully",
      addProfile: "Add Profile",
      profileAddedSuccessfully: "Profile added successfully",
      removeProfile: "Remove Profile",
      profileRemovedSuccessfully: "Profile removed successfully",
      roleUpdate: "Role Update",
      updatedSuccessfully: "Updated successfully",
      profileUpdate: "Profile Update",
      profileUpdatedSuccessfully: "Profile updated successfully"
    },
    title: "Talent Pool",
    reviewRequest: "Review Request",
    // Main talent pool
    noPendingRequest: "No pending request found",
    importFrom: "Import from",
    uploadExcel: "upload excel",
    uploadResumes: "upload resumes",
    uploadResumesTooltip: "Import from Resumes (PDF)",
    orHRIS: "or HRIS",
    pendingRequest: "Pending Request",
    allUsers: "All Users",
    addNewEmployee: "Add New Employee Card",
    // Table headers
    name: "Name",
    email: "Email",
    maxRole: "Max Role",
    relationships: "Relationships",
    action: "Action",
    // User search
    searchUser: "Search User",
    userNotFound: "User not found.",
    // Relationship management
    member: "Member",
    relationship: "Relationship",
    addRelation: "Add relation",
    removeRelationship: "Remove Relationship",
    // Add employee form
    firstName: "First Name",
    lastName: "Last Name",
    roleTitle: "Role Title",
    save: "Save",
    // Import
    importFromExcel: "Import from Excel"
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Frequently Asked Questions",
    question1: "How do I manage my organization settings?",
    question2: "How can I invite new members to my organization?",
    question3: "What are the different user roles and permissions?",
    question4: "How do I customize my organization's branding?",
    helpText: "This is placeholder help text. Please contact support for specific assistance with your organization settings and configuration."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Organization Name",
    organizationUsername: "Organization Username",
    website: "Website",
    workEmail: "Work Email",
    location: "Location",
    organizationType: "Organization Type",
    primaryThemeColor: "Primary Theme Color",
    secondaryThemeColor: "Secondary Theme Color",
    about: "About",
    saveChanges: "Save Changes",
    usernameExists: "This username already exists",
    usernameAvailable: "This username is available",
    organizationTypeOptions: {
      business: "Business", 
      academic: "Academic",
      recruiter: "Recruiter"
    },
    logo: {
      adjustTitle: "Adjust Organization Logo",
      save: "Save",
      uploadButton: "Upload Logo",
      incorrectFileType: "Incorrect File Type",
      incorrectFileTypeText: "Please upload a supported image file type, e.g. jpg, png, etc.",
      fileSizeExceeded: "Image File Size Exceeded",
      fileSizeExceededText: "The size of the profile picture should be less than 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Select",
    acceptInvitation: "Accept Invitation",
    noOrganizationFound: "No Organization Found!",
    noOrganizationSubtext: "Curate your own organization first.",
    createOrganization: "Create Organization",
    myOrganizations: "My Organizations",
    viewAllOrganizations: "View All Organizations",
    pendingInvitation: "Pending",
    currentOrg: "Current Organization"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Welcome Back! 👋",
    setupComplete: "Setup Complete!",
    setupProgress: "Setup: {step} of 4",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    criticalRoles: "Critical Roles",
    talentPool: "Talent Pool", 
    integrations: "Integrations",
    onboarding: "Onboarding",
    activeCandidates: "Active Candidates",
    connectedApps: "Connected Apps",
    pendingOnboards: "Pending Onboards",
    kvdrReportsCenter: "KVDR Reports Center",
    kvdrReportsDescription: "Dive deep into your key visual data reports and gain critical insights.",
    exploreReports: "Explore Reports >",
    talentPoolExplorer: "Talent Pool Explorer",
    talentPoolDescription: "Discover, analyze, and manage your top talent with comprehensive insights.",
    exploreTalentPool: "Explore Talent Pool >",
    thisMonth: "this month",
    goToOnboarding: "Go to Onboarding"
  },

  // Reports
  reports: {
    title: "Reports",
    nineCellMatrix: "9 Cell Matrix",
    xyPlot: "Scatter Plot",
    talentScoreCard: "Talent Scorecard",
    emptyReports: "Empty Reports",
    createKVDRFirst: "Create a KVDR and plan first to view reports",
    // XY Plot specific
    xAxis: "X-Axis",
    yAxis: "Y-Axis",
    bubbleSize: "Bubble Size",
    loadingChart: "Loading chart...",
    howToReadChart: "How to read this chart",
    positioning: "Positioning",
    horizontalPosition: "Horizontal position shows",
    verticalPosition: "Vertical position shows",
    bubbleRepresentation: "Bubble Representation",
    eachBubbleRepresents: "Each bubble represents an employee",
    sizeIndicates: "Size indicates",
    quadrants: "Quadrants",
    topLeft: "Top-Left",
    topRight: "Top-Right",
    bottomLeft: "Bottom-Left",
    bottomRight: "Bottom-Right",
    low: "Low",
    high: "High",
    interaction: "Interaction",
    hoverOverBubble: "Hover over any bubble",
    revealsDetailedMetrics: "Reveals detailed metrics for that employee",
    colorCoding: "Color coding",
    differentColorsHelp: "Different colors help distinguish employees",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Nine-Cell Matrix Employee Categorization",
    methodologyDescription: "Standardized methodology based on Performance Score and Succession Readiness",
    loading: "Loading...",
    preparingMatrix: "Preparing the Nine-Cell Matrix...",
    noDataAvailable: "No data available",
    employeeAssessmentRequired: "Employee assessment data is required to display the Nine-Cell Matrix.",
    successionReadiness: "Succession Readiness",
    performanceScore: "Performance Score",
    bargain: "BARGAIN",
    bind: "BIND",
    backup: "BACKUP",
    onTrack: "ON TRACK",
    boost: "BOOST",
    build: "BUILD",
    bootBarter: "BOOT/BARTER",
    employees: "Employees",
    methodologyTitle: "Nine-Cell Matrix Methodology",
    methodologySubtitle: "Standardized employee categorization based on Performance Score and Succession Readiness calculations.",
    calculationMethod: "Calculation Method",
    performanceScoreFormula: "Performance Score (P)",
    performanceScoreCalculation: "P = 0.6 × Performance + 0.4 × Appraisal",
    performanceScoreNote: "Raw scores (-1 to 1.5) are normalized to 0-100 scale",
    successionReadinessFormula: "Succession Readiness (R)",
    successionReadinessCalculation: "R = 0.5 × Succession + 0.3 × Fitment + 0.2 × Years Score",
    successionReadinessNote: "Raw scores (-1 to 1.5) are normalized to 0-100 scale",
    yearsScore: "Years Score",
    yearsScoreCalculation: "If Years ≥ 3: 100, else: (Years / 3) × 100",
    yearsScoreNote: "Currently using default 2 years (configurable)",
    cellCategories: "Cell Categories",
    backupDescription: "High Performance, High Succession",
    boostDescription: "Medium Performance, High Succession",
    bindDescription: "High/Medium Succession, Low/Medium Performance",
    onTrackDescription: "Medium/Low Performance, Medium/Low Succession",
    buildDescription: "Medium Performance, Low Succession",
    bargainDescription: "Low Performance, High Succession",
    bootBarterDescription: "High Performance, Low Succession",
    // Talent Score Card specific
    criteria: "Criteria",
    talent: "TALENT",
    role: "ROLE",
    remarks: "REMARKS",
    weightage: "Weightage",
    good: "Good (8-10)",
    average: "Average (5-7)",
    poor: "Poor (1-4)",
    notApplicable: "Not Applicable"
  },


  // Users
  users: {
    title: "Users",
    manageUsers: "Manage Users",
    // User Recommendations
    talentRecommendations: "Talent Recommendations",
    recommendationsDescription: "Based on your KVDR assessment, here are personalized recommendations your organization",
    viewActivePlans: "View Active Plans",
    // Recommendation Cards
    fitmentPlan: "Fitment Plan",
    fitmentPlanDescription: "Onboarding people to their roles.",
    fitmentPlanContent: "Onboarding people to their roles. Mapping right talent to right roles with fitment indicators",
    developmentPlan: "Development Plan",
    developmentPlanDescription: "AI-Powered Learning with ALEX",
    developmentPlanContent: "Creating Learning plans with ALEX Personalized learning paths to increase talent value with skills.",
    successionPlanning: "Succession Planning",
    successionPlanningDescription: "Promote and support career growth",
    successionPlanningContent: "Promote and support career growth Coaching plans for skill and time readiness to the next role.",
    // Benefits Lists
    roadToRole: "Road to your Role (Journey)",
    skillProfiling: "Skill profiling",
    learningCredits: "Learning credits",
    marketRewards: "Market rewards",
    customLearningPaths: "Custom learning paths",
    aiAssistedValidation: "AI assisted validation",
    progressTracking: "Progress tracking with Experience Points (XPs)",
    interactiveExercises: "Interactive exercises",
    appraisalIndicators: "360 Apprasial indicators",
    goalSettingMentorship: "Goal Setting & Mentorship",
    behaviouralCoaching: "Behavioural Coaching & Plans",
    managedCareerGuidance: "Managed Career Guidance",
    // Action Buttons
    onboard: "Onboard",
    activate: "Activate",
    promote: "Promote",
    // Progress Section
    talentCapabilitySnapshot: "Talent Capability Snapshot",
    lastUpdated: "Last updated: Today",
    refresh: "Refresh",
    // Score Labels
    industryLeader: "Industry Leader",
    highPerforming: "High Performing",
    competitive: "Competitive",
    developing: "Developing",
    foundationBuilding: "Foundation Building",
    // Notifications
    alexActivated: "ALEX Activated",
    alexActivatedText: "Your AI learning assistant is ready to help!",
    coachingRequestSent: "Coaching Request Sent",
    coachingRequestSentText: "A coach will contact you shortly!",
    rewardsMarketplace: "Rewards Marketplace",
    rewardsMarketplaceText: "Exploring available rewards and perks!"
  },

  // Integrations
  integrations: {
    title: "Integrations",
    manageIntegrations: "Manage Integrations"
  },

  // Admins
  admins: {
    title: "Admins",
    manageAdmins: "Manage Admins"
  }
};
